module.exports = __webpack_public_path__ + "static/media/AAO_Dental_Trauma_Flyer_FINAL-NEW-LOGO-2011.feff7a13.pdf";